import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { useOrderAuth } from "./OrderAuthContext";
import "../css/orders.scss";

function OrderLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, login } = useOrderAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const destination = location.state?.from || "/orders";

  if (isAuthenticated) {
    return <Navigate to="/orders" replace />;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");

    if (login(username.trim(), password)) {
      navigate(destination, { replace: true });
      return;
    }

    setError("Incorrect username or password.");
  };

  return (
    <div className="orders-page">
      <Header />
      <main className="order-login" id="MainContent">
        <section
          className="order-login__card"
          aria-labelledby="order-login-title"
        >
          <div className="order-login__mark" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <rect x="5" y="10" width="14" height="10" rx="1" />
              <path d="M8 10V7a4 4 0 0 1 8 0v3" />
            </svg>
          </div>
          <p className="orders-page__eyebrow">Restricted area</p>
          <h1 id="order-login-title">Order access</h1>
          <p className="order-login__intro">
            Sign in to view customer orders, shipping addresses, and tracking
            information.
          </p>

          <form className="order-login__form" onSubmit={handleSubmit}>
            <label>
              <span>Username</span>
              <input
                type="text"
                autoComplete="username"
                value={username}
                onChange={(event) => setUsername(event.target.value)}
                required
                autoFocus
              />
            </label>
            <label>
              <span>Password</span>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </label>

            {error ? (
              <p className="order-login__error" role="alert">
                {error}
              </p>
            ) : null}

            <button type="submit">Sign in</button>
          </form>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default OrderLogin;
